import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { _get_i18Lang } from "../i18n";
import { useTranslation } from "react-i18next";
import loginLogo from "../assets/img/loginLogo.png";
import signinfacebook from "../assets/img/loginwithfacebook.svg";
import signinmobileno from "../assets/img/loginwithmobileno.png";
import "../Styles/Login.css";
import "../Styles/Profile.css";
import LoginServices from "../Services/Login";
import "react-phone-number-input/style.css";
import { v4 as uuidv4 } from 'uuid';

import jwt_decode from "jwt-decode";
import { BookContentType } from "./Epub";
import Loading from "../Components/Loading";

import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css'; // Importing library styles
import { Modal, Button, Alert } from "react-bootstrap";
import {
  CredentialResponse,
} from "@react-oauth/google";
import { useUser } from "../Contexts/UserContext";

// Configuration constant to control detailed error display
const SHOW_DETAILED_ERRORS = true; // Set to false to hide detailed error information

declare global {
  interface Window {
    google: any; // Or a more specific type if you know it
  }
}

interface LogInModalProps {
  opens: boolean;
  onCloses: () => void;
  onLoginStateChange: (newState: boolean) => void;
}

declare global {
  interface Window {
    fbAsyncInit: () => void;
    FB: any;
  }
}

export const LogInModel: React.FC<LogInModalProps> = ({
  opens,
  onCloses: onClose,
  onLoginStateChange,
}) => {

  const { setUserImg } = useUser();
  const { t } = useTranslation();
  const [phoneModel, setPhoneModel] = useState<boolean>(false);
  const [phoneNumber, setPhoneNumber] = useState<any>("");
  const currlang = localStorage.getItem("lan");
  const navigate = useNavigate();
  const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

  const [isGoogleLoaded, setIsGoogleLoaded] = useState(false);

  useEffect(() => {
    const checkGoogleOAuth = () => {
      if (window.google && window.google.accounts) {
        setIsGoogleLoaded(true);
      }
    };

    checkGoogleOAuth();
    const timer = setTimeout(checkGoogleOAuth, 2000);
    return () => clearTimeout(timer);
  }, []);


  // Debug Google Client ID
  useEffect(() => {
    if (!GOOGLE_CLIENT_ID) {
      handleDetailedError(
        new Error('Google Client ID is not configured in environment variables'),
        'Google OAuth Configuration'
      );
    }
  }, [GOOGLE_CLIENT_ID]);

  // Error state for detailed error display
  const [errorDetails, setErrorDetails] = useState<{
    show: boolean;
    title: string;
    message: string;
    details?: string;
  }>({
    show: false,
    title: '',
    message: '',
    details: ''
  });

  // Detailed Error Handler Function
  const handleDetailedError = (error: any, context: string) => {

    let errorMessage = "An error occurred. Please try again.";
    let errorDetails = "";

    if (error) {
      // Extract error message
      if (error.message) {
        errorMessage = error.message;
      } else if (typeof error === 'string') {
        errorMessage = error;
      }

      // Extract detailed error information
      if (SHOW_DETAILED_ERRORS) {
        if (error.stack) {
          errorDetails = error.stack;
        } else if (error.response) {
          errorDetails = `Status: ${error.response.status}\nData: ${JSON.stringify(error.response.data, null, 2)}`;
        } else if (error.code) {
          errorDetails = `Error Code: ${error.code}\nError: ${JSON.stringify(error, null, 2)}`;
        } else {
          errorDetails = JSON.stringify(error, null, 2);
        }
      }
    }

    setErrorDetails({
      show: true,
      title: `${context} Failed`,
      message: errorMessage,
      details: errorDetails
    });

    // Auto-hide error after 10 seconds
    setTimeout(() => {
      setErrorDetails(prev => ({ ...prev, show: false }));
    }, 10000);
  };

  // Close Error Alert
  const closeErrorAlert = () => {
    setErrorDetails(prev => ({ ...prev, show: false }));
  };

  const [countryCode, setCountryCode] = useState<any>("+91");
  const [confirmation, setConfirmation] = React.useState<any>();
  const [result, setResult] = React.useState<string>("");
  const [isOtp, setIsOTP] = React.useState<boolean>(false);
  const [enterOtp, setEnterOtp] = useState("");
  const [pnModel, setPnModel] = useState(false);

  const [notification, setNotification] = useState(false);

  // const [notificationresendotp, setNotificationresendotp] = useState(false);

  const [inputElement, setInputElement] = useState<HTMLInputElement>();

  const RESEND_OTP_TIME_LIMIT = 2 * 60; // 2 minutes in seconds
  // const RESEND_OTP_TIME_LIMIT = 30; // 30 seconds minutes in seconds

  const [timeLeft, setTimeLeft] = useState(RESEND_OTP_TIME_LIMIT);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  const resendLimit = 4;
  const resends = localStorage.getItem("resends") as any;

  const handlePhoneChange = (value: any, data: any) => {
    const numberWithoutDialCode = value?.replace(`+${data?.country?.dialCode}`, '')?.trim();
    if (data?.country?.dialCode !== "91") {
      setPhoneNumber(numberWithoutDialCode);
      setCountryCode("91")
    } else {
      setPhoneNumber(numberWithoutDialCode);
      setCountryCode(data?.country?.dialCode)
    }
  };

  const signInWithPhoneNumber = async (phone: string) => {
    if (phone !== "") {
      try {
        const confirmation = LoginServices.sendOtp(phone, "1").then(
          (res: any) => {
            // localStorage.setItem("oldid", JSON.stringify(res.result));
            setResult(res.result);
            res.resuult &&
              localStorage.setItem(
                "resends",
                resends ? (parseInt(resends) + 1).toString() : "1"
              );
          }
        );
        setConfirmation(confirmation);
        setIsOTP(true);
      } catch (error) {
        console.log("error", error);
      }
    } else {
      console.log("false otp");
    }
  };

  const [FcmToken, setFcmToken] = useState('');

  useEffect(() => {
    // let id: any = localStorage.getItem('fcm_token');
    // if (!id) {
    const id = uuidv4();
    // localStorage.setItem('fcm_token', id);
    setFcmToken(id);
    // }
  }, []);

  const confirmOTP = async (code: any) => {
    try {
      LoginServices.validOtp(result, enterOtp).then((res: any) => {
        if (res?.result === false) {
          setNotification(true);
        }
        if (res.status && res.result) {
          LoginServices.getUserLogin(
            countryCode,
            phoneNumber,
            "",
            "1",
            "",
            "",
            FcmToken,
            ""
          ).then((res: any) => {
            if (res?.status) {
              localStorage?.setItem("signInMode", "1")
              localStorage?.setItem("fixedUserId", res?.result?.fixedUserId)

              localStorage.setItem("UserId", res?.result?.userId);
              localStorage.setItem("UserName", res?.result?.name);
              localStorage.setItem("Image", res?.result?.imageThumbPath);
              localStorage.setItem("Phone", res?.result?.phoneNumber);
              localStorage.setItem("Token", res?.result?.token);
              localStorage.setItem("SignKey", res?.result?.signKey);
              onLoginStateChange(true);
              window?.location?.reload()
            }
          });
          onClose();
          setPhoneModel(false);
        } else {
          console.log("res.result is false");
        }
      });
      await confirmation(code);
    } catch (error) {
      console.log("error", error);
    }
  };

  const calculateTimeLeft = () => {
    const firstResendTimestamp = localStorage.getItem("firstResendTimestamp");
    if (firstResendTimestamp) {
      const now = new Date().getTime();
      const firstResendTime = new Date(
        parseInt(firstResendTimestamp)
      ).getTime();
      const timePassed = now - firstResendTime;
      // const timeLeft = 24 * 60 * 60 * 1000 - timePassed;
      const timeLeft = 60 * 10000 - timePassed;
      return timeLeft > 0 ? timeLeft : null;
    }
    return null;
  };

  const handleResendOTP = async () => {
    const firstResendTimestamp = localStorage.getItem("firstResendTimestamp");
    const now = new Date().getTime();

    if (!firstResendTimestamp) {
      localStorage.setItem("firstResendTimestamp", now.toString());
    }

    if (resends && parseInt(resends) >= resendLimit) {
      const timeLeft = calculateTimeLeft();
      if (timeLeft !== null) {
        // setNotificationresendotp(true)
        // alert(`You have reached the maximum resend attempts. Try again in ${Math.ceil(timeLeft / (60 * 60 * 1000))} hours.`);
        return;
      } else {
        localStorage.setItem("resends", "1");
        localStorage.setItem("firstResendTimestamp", now.toString());
      }
    } else {
      localStorage.setItem(
        "resends",
        resends ? (parseInt(resends) + 1).toString() : "1"
      );
      setPnModel(true);
      // Reset the timer
      setTimeLeft(RESEND_OTP_TIME_LIMIT);
      setIsButtonDisabled(true);
    }
    await signInWithPhoneNumber(phoneNumber);
  };

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
  };

  const resetTimer = () => {
    setTimeLeft(RESEND_OTP_TIME_LIMIT);
    setIsButtonDisabled(true);
    // setResendAttempts(0);
  };

  const formatPhoneNumber = (phoneNumber: any) => {
    const firstPart = phoneNumber?.slice(0, 2); // First two digits
    const lastPart = phoneNumber?.slice(-2); // Last two digits
    const maskedPart = "xxxxxx"; // Masked middle part
    return `${firstPart}${maskedPart}${lastPart}`;
  };

  const formattedPhoneNumber = formatPhoneNumber(phoneNumber);

  useEffect(() => {
    if (phoneModel) {
      resetTimer();
    }
    setPnModel(false);
  }, [phoneModel]);

  useEffect(() => {
    if (inputElement) {
      inputElement?.focus();
    }
  }, [inputElement]);

  useEffect(() => {
    if (phoneNumber !== undefined) {
      if (timeLeft === 0) {
        setIsButtonDisabled(false);
        return;
      }

      const timerId = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(timerId);
    }
  }, [timeLeft, confirmation]);

  useEffect(() => {
    // Set a timeout to remove the item after 24 hours (24 * 60 * 60 * 1000 milliseconds)
    const timeoutId = setTimeout(() => {
      setPhoneModel(false);
      localStorage.removeItem("resends");
    }, 24 * 60 * 60 * 1000);
    // }, 60 * 10000);

    // Cleanup the timeout if the component unmounts
    return () => clearTimeout(timeoutId);
  }, [localStorage, resends]);

  // token refresh functions

  const [tokenStatus, setTokenStatus] = useState<any>(false);
  // const hiteffect = localStorage.getItem("AudioId");
  const Type = BookContentType;
  const [loading, setLoading] = useState(false);

  const isTokenExpired = (token: string | null) => {
    if (!token) return true;

    try {
      const token = localStorage.getItem("Token") as any;
      const payload = JSON.parse(atob(token.split('.')[1]));
      const expiry = new Date(payload.exp * 100000);

      // const decodedToken = jwt_decode(token) as any;
      // const currentTime = Math.floor(Date.now() / 1000); // current time in seconds

      // Check if the token has expired
      // return decodedToken.exp < currentTime;
    } catch (error) {
      console.error("Invalid token:", error);
      return true;
    }
  };
  const UserId = localStorage.getItem("UserId") as any;
  const Token = localStorage.getItem("Token") as any; // You would replace this with your actual token retrieval logic

  useEffect(() => {
    if (isTokenExpired(Token) || tokenStatus == true) {
      LoginServices.refreshToken().then((res: any) => {
        if (res.status) {
          localStorage.setItem("Token", res?.result?.token);
          localStorage.setItem("SignKey", res?.result?.signKey);
          localStorage.setItem("UserId", res?.result?.userId);
        }
      });
      setTokenStatus(true);
      console.log("Token has expired.");
      // Here, you can also redirect to the login page, or refresh the token
    } else {
      setTokenStatus(false);
      console.log("Token is still valid.");
    }
  }, [Type]);
  // }, [ hiteffect, Type]);

  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: "291301805425699", // Replace with your app ID
        autoLogAppEvents: true,
        xfbml: true,
        version: "v12.0",
      });
    };


    (function (d, s, id) {
      let js: HTMLScriptElement | null;
      const fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s) as HTMLScriptElement;
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs?.parentNode?.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  useEffect(() => {
    if (window?.location?.pathname === null) {
      navigate(`/home`)
    }
  }, [window.location.pathname])

  const [message, setMessage] = useState("");

  const handleClick = () => {
    setMessage(
      localStorage.getItem("lan") === "hindi" ?
        "यह सेवा केवल भारतीय नंबर के लिए उपलब्ध है |"
        : "This service is only available for Indian number")
    setTimeout(() => {
      setMessage("")
    }, 2000);
  };

  // Add this useEffect to check if Google OAuth is loading properly
  useEffect(() => {
    // Check if Google OAuth script is loaded
    const checkGoogleOAuth = () => {
      if (window.google && window.google.accounts) {
      } else {
      }
    };

    checkGoogleOAuth();

    // Check again after a delay
    const timer = setTimeout(checkGoogleOAuth, 2000);

    return () => clearTimeout(timer);
  }, []);

  // Google Login Success Handler  

  const handleGoogleLoginSuccess = async (credentialResponse: CredentialResponse) => {
    console.log('Google login success triggered', credentialResponse);

    try {
      if (credentialResponse.credential) {
        setLoading(true); // Show loader immediately when Google login succeeds

        const decoded: {
          name: string;
          email: string;
          picture: string;
          sub: string;
        } = jwt_decode(credentialResponse.credential);

        const name = decoded.name;
        const email: any = decoded.email;
        const token = credentialResponse.credential;
        const userimage = decoded.picture;

        console.log('Decoded user info:', { name, email });

        const res = await LoginServices.getUserLogin(
          "",
          "",
          email,
          "2",
          name,
          userimage,
          token,
          ""
        );

        if (res?.status) {
          localStorage?.setItem("signInMode", "2");
          localStorage?.setItem("fixedUserId", res?.result?.fixedUserId);
          console.log(res?.result?.fixedUserId, "fixeduserid===")
          localStorage.setItem("UserId", res?.result?.userId);
          localStorage.setItem("UserName", res?.result?.name);
          localStorage.setItem("Image", res?.result?.imagePath);
          localStorage.setItem("Email", res?.result?.email);
          localStorage.setItem("Token", res?.result?.token);
          localStorage.setItem("SignKey", res?.result?.signKey);
          onLoginStateChange(true);
          window.location.reload();
          onClose();
        } else {
          // If login API fails, hide loader and show error
          setLoading(false);
          handleDetailedError(new Error("Login failed - server response error"), "Google Login");
        }
      }
    } catch (error) {
      console.error('Google login error:', error);
      setLoading(false); // Hide loader on error
      handleDetailedError(error, "Google Login");
    }
    // Remove the finally block - loader will be hidden only after successful login or on error
  };

  // Facebook Login Handler
  const handleFacebookLogin = () => {
    window?.FB?.login(
      (response: any) => {
        if (response.authResponse) {
          window.FB.api(
            "/me",
            { fields: "last_name, first_name, email" },
            (userInfo: any) => {
              try {
                const phoneNum = userInfo
                const email: string = userInfo.email;
                const accessToken: string = response.authResponse.accessToken;
                localStorage.setItem("fcm", accessToken);

                const name: string = userInfo.last_name
                  ? `${userInfo.first_name} ${userInfo.last_name}`
                  : userInfo.first_name;

                const image: string = encodeURI(
                  `https://graph.facebook.com/${userInfo.id}/picture?type=large&width=1080`
                );
                LoginServices.getUserLogin(
                  "",
                  "",
                  email,
                  "3",
                  name,
                  "",
                  accessToken,
                  userInfo.id
                ).then((res: any) => {
                  if (res?.status) {
                    // window?.location?.reload()
                    localStorage?.setItem("signInMode", "3")
                    localStorage?.setItem("fixedUserId", res?.result?.fixedUserId)
                    localStorage.setItem("UserId", res?.result?.userId);
                    localStorage.setItem("Token", res?.result?.token);
                    localStorage.setItem("SignKey", res?.result?.signKey);
                    localStorage.setItem("UserName", res?.result?.userName);
                    localStorage.setItem("UserImage", res?.result?.userImage);
                    window?.location?.reload()
                  } else {
                    handleDetailedError(new Error("Facebook login failed - server response error"), "Facebook Login");
                  }
                }).catch((error: any) => {
                  handleDetailedError(error, "Facebook Login");
                });
                onClose();
              } catch (error) {
                handleDetailedError(error, "Facebook Login");
              }
            }
          );
        } else {
          handleDetailedError(new Error("Facebook login was cancelled or failed"), "Facebook Login");
        }
      },
      { scope: "email" }
    );
  };

  // Phone Number Login Handler
  const handlePhoneNumberLogin = () => {
    if (resends >= resendLimit === false) {
      if (phoneNumber !== undefined && phoneNumber?.length === 10) {
        signInWithPhoneNumber(phoneNumber);
        setPnModel(true);
      }
    }
  };

  // OTP Confirmation Handler
  const handleOtpConfirmation = () => {
    confirmOTP(enterOtp);
  };

  // Resend OTP Handler
  const handleResendOtp = () => {
    handleResendOTP();
  };

  useEffect(() => {
    if (opens && isGoogleLoaded && GOOGLE_CLIENT_ID) {
      try {
        window.google.accounts.id.initialize({
          client_id: GOOGLE_CLIENT_ID,
          callback: handleGoogleLoginSuccess,
          ux_mode: "popup",
          auto_select: false,
          allowed_parent_origin: window.location.origin
        });

        const googleButtonContainer = document.getElementById('googleSignInButton');
        const lang = localStorage?.getItem("locale");

        if (googleButtonContainer) {
          window.google.accounts.id.renderButton(
            googleButtonContainer,
            {
              theme: "outline",
              size: "large",
              text: "signin_with",
              shape: "rectangular",
              logo_alignment: "left",
              width: "338",
              locale: lang
            }
          );
        } else {
        }
      } catch (error) {
        handleDetailedError(error, "Google Sign-In Initialization");
      }
    }
  }, [opens, isGoogleLoaded, GOOGLE_CLIENT_ID]);

  useEffect(() => {
    if (opens) {
      setLoading(false); // Reset loading when modal opens
    }
  }, [opens]);

  return (
    <>
      <Modal
        show={opens}
        onHide={() => {
          onClose();
          setPhoneModel(false);
          setIsOTP(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="loginpag"
      >
        <Modal.Body>
          {/* Detailed Error Alert */}
          {errorDetails.show && (
            <Alert
              variant="danger"
              dismissible
              onClose={closeErrorAlert}
              style={{ marginBottom: "20px" }}
            >
              <Alert.Heading>{errorDetails.title}</Alert.Heading>
              <p>{errorDetails.message}</p>
              {SHOW_DETAILED_ERRORS && errorDetails.details && (
                <>
                  <hr />
                  <p className="mb-0">
                    <strong>Technical Details:</strong>
                  </p>
                  <pre style={{
                    fontSize: "12px",
                    backgroundColor: "#f8f9fa",
                    padding: "10px",
                    borderRadius: "4px",
                    overflow: "auto",
                    maxHeight: "200px"
                  }}>
                    {errorDetails.details}
                  </pre>
                </>
              )}
            </Alert>
          )}

          {/* Show loader when loading is true */}
          {loading ? (
            <div style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "200px",
              flexDirection: "column"
            }}>
              <Loading />
              <p style={{
                marginTop: "10px",
                fontFamily: "ChanakyaUni",
                fontSize: "16px",
                color: "#666"
              }}>
                {currlang === "hindi" ? "लॉगिन हो रहा है..." : "Logging in..."}
              </p>
            </div>
          ) : (
            <>
              <div style={{ textAlign: "center" }}>
                <div style={{ display: "inline-grid" }}>
                  <img
                    src={loginLogo}
                    alt=""
                    className="login-logo"
                  />
                  <div className="login-info-box">
                    {currlang === "hindi" ? (
                      <p className="login-info-text-hindi">
                        इस सुविधा का उपयोग करने के लिए आपको लॉगिन करने की आवश्यकता है।
                        यह पूर्णतः नि:शुल्क तथा सुरक्षित है।
                      </p>
                    ) : (
                      <p className="login-info-text-en">
                        You must login to use this feature. It is completely free and
                        secure.
                      </p>
                    )}
                  </div>
                  <label className="login-title">
                    {t("login_option_tr")}
                  </label>
                </div>
              </div>
              <div className="textCenter">
                {!isGoogleLoaded ? (
                  <div>
                    <div>Loading Google Sign-In...</div>
                    <button
                      onClick={() => setIsGoogleLoaded(false)}
                      style={{ marginTop: '10px', padding: '5px 10px' }}
                    >
                      Skip Google Sign-In
                    </button>
                  </div>
                ) : (
                  <div id="googleSignInButton" className="google-login-container"></div>
                )}

                <div
                  className="loginbuttons"
                  style={{
                    cursor: "pointer",
                  }}
                  onClick={handleFacebookLogin}
                >
                  <img
                    src={signinfacebook}
                    alt="signinfacebook"
                    width="18px"
                    height="18px"
                    className="login-facebook-img"
                  />
                  {t("login_With_Facebook_tr")}
                </div>
                <div
                  className="loginbuttons"
                  onClick={() => setPhoneModel(true)}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={signinmobileno}
                    alt="signinmobileno"
                    width="20px"
                    height="20px"
                    className="login-mobile-img"
                  />
                  {t("login_With_MobileNo_tr")}
                </div>
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="dark" onClick={() => onClose()}>
            {t("Cancel_tr")}
          </Button>
        </Modal.Footer>
      </Modal>
      {phoneModel && (
        <>
          <Modal show={phoneModel} centered style={{ transform: 'translateX(-5px)' }}>
            <div>
              <div style={{ display: "grid", justifyContent: "center", marginTop: "40px" }}>
                <img src={loginLogo} alt="" style={{ marginLeft: "15%" }} />
                <label
                  style={{
                    fontSize: "30px",
                    textAlign: "center",
                    padding: "0 0 10px",
                    fontFamily: "ChanakyaUni",
                    color: "#212121",
                  }}
                >
                  {t("login_With_MobileNo_tr")}
                </label>
              </div>
            </div>

            <div style={{ margin: pnModel ? "0px" : "5% 5px" }}>
              <div
                className="loginbuttons-Otp">
                {pnModel ? (
                  <div style={{ margin: "5% 4px" }}>
                    <div
                      style={{
                        width: "320px",
                        background: "#FCF0E2",
                        borderRadius: "5px",
                        boxShadow: "#000 0px 0px 5px -1px",
                        textAlign: "center",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "ChanakyaUni",
                          fontSize: "19px",
                          color: "#000",
                          lineHeight: "20px",
                          padding: "8px",
                          fontWeight: 500,
                        }}
                      >
                        {currlang === "hindi"
                          ? "कृपया SMS के माध्यम से " + "+" + countryCode + " " +
                          formattedPhoneNumber +
                          " पर भेजा गया ओटीपी (OTP) दर्ज करें।"
                          : "Please enter the One Time Password (OTP) sent to +91 " +
                          formattedPhoneNumber +
                          " via sms."}
                      </p>
                    </div>
                    <label
                      style={{ fontSize: "22px", fontFamily: "ChanakyaUni", margin: "0" }}
                    >
                      {t("enter_otp_tr")}
                    </label>
                    <div style={{ width: "max-content" }}>
                      <input
                        autoFocus
                        value={enterOtp}
                        type="number"
                        maxLength={10}
                        placeholder={t("enter_otp_tr")}
                        style={{
                          border: "1px solid #EB7D16",
                          borderRadius: "5px",
                        }}
                        onChange={(e) => {
                          let v = e.currentTarget?.value ?? undefined;
                          setEnterOtp(v);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleOtpConfirmation();
                          }
                        }}
                      />
                      <button
                        onClick={handleOtpConfirmation}
                        style={{
                          margin: "5px 0 0 25px",
                          borderRadius: "5px",
                          color: "black",
                          borderColor: "burlywood",
                        }}
                      >
                        Confirm
                      </button>

                      <div style={{ display: "flex" }}>
                        <p style={{ margin: "10px 18px 0 0" }}>
                          Time left to resend OTP: {formatTime(timeLeft)}
                        </p>
                        <label
                          onClick={handleResendOtp}
                          style={{
                            margin: "8px 0 0 0",
                            borderRadius: "5px",
                            color: "black",
                            border: "1px solid #EB7D16",
                            padding: "0 5px",
                            display: isButtonDisabled ? "none" : "block",
                          }}
                        >
                          Resend OTP
                        </label>
                      </div>
                    </div>
                    {notification && (
                      <div style={{ color: "red" }}>{t("otp_validation")}</div>
                    )}
                    {resends >= resendLimit === true && (
                      <div style={{ color: "red" }}>
                        {localStorage.getItem("lan") === "hindi"
                          ? "आपने ओटीपी अनुरोधों की सीमा, जो 4 गुना पर सेट है, पार कर ली है। कृपया बाद में पुनः प्रयास करें/24 घंटे बाद प्रयास करें ।"
                          : "You have exceeded the limit of OTP requests, which is set to 4 times. Please try again later / try after 24 hours ।."}
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    <div
                      style={{
                        width: "320px",
                        background: "#FCF0E2",
                        borderRadius: "5px",
                        boxShadow: "#000 0px 0px 5px -1px",
                        textAlign: "center",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "ChanakyaUni",
                          fontSize: "19px",
                          color: "#000",
                          lineHeight: "20px",
                          padding: "8px",
                          fontWeight: 500,
                        }}
                      >
                        {currlang === "hindi"
                          ? "कृपया अपना दस अंकों का मोबाइल नंबर बिना +91 या 0 लगाये दर्ज करें |"
                          : "Please enter only 10 digit mobile number without any country code +91 or 0"}
                      </p>
                    </div>
                    <div style={{ display: "flex" }}>
                      <div style={{ display: "flex", border: "1px solid #dcdcdc", borderBottomLeftRadius: "5px", borderTopLeftRadius: "5px", cursor: "pointer" }}
                        onClick={handleClick}>
                        <img src="https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/1f1ee-1f1f3.svg" width="24px" height="24px"
                          style={{ margin: "4px 0 0 7px" }} />
                        <div className="react-international-phone-country-selector-button__dropdown-arrow" style={{ margin: "15px 5px 0 5px" }} />
                        <p
                          style={{
                            borderRight: "none",
                            borderTop: "none",
                            borderBottom: "none",
                            borderLeft: "1px solid #dcdcdc",
                            width: "40px",
                            padding: "1px 0 0 5px",
                            margin: "0"
                          }}
                        // onClick={handleClick}
                        >+91</p>
                      </div>
                      {/* <PhoneInput
                        ref={(input: any) => setInputElement(input)}
                        placeholder={t("enter_mobile_no")}
                        defaultCountry="in"
                        forceDialCode={true}
                        onChange={handlePhoneChange}
                      /> */}
                      <input ref={(input: any) => setInputElement(input)}
                        type="number"
                        maxLength={10}
                        size={10}
                        placeholder={t("enter_mobile_no")}
                        value={phoneNumber}
                        style={{ border: "1px solid #EB7D16", borderRadius: "2px", width: "50%", padding: "0 0 0 10px", fontSize: "20px" }}
                        onFocus={(e) => (e.target.style.border = "1px solid #dcdcdc")}
                        onBlur={(e) => (e.target.style.border = "1px solid #dcdcdc")}
                        onChange={(e) => {
                          let v = e.currentTarget?.value ?? undefined;
                          // if (/^\d*$/.test(v) && v?.length === 10) {
                          if (e.target.value.length <= 10) {
                            setCountryCode("91")
                            setPhoneNumber(v);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handlePhoneNumberLogin();
                          }
                        }}
                      />
                      <button
                        style={{
                          margin: "0 0 0 25px",
                          borderRadius: "5px",
                          color: "black",
                          borderColor: "burlywood",
                          width: "95px"
                        }}
                        onClick={handlePhoneNumberLogin}
                      >
                        {t("login_tr")}
                      </button>
                    </div>
                    {resends >= resendLimit === true && (
                      <div style={{ color: "red" }}>
                        {localStorage.getItem("lan") === "hindi"
                          ? "आपने ओटीपी अनुरोधों की सीमा, जो 4 गुना पर सेट है, पार कर ली है। कृपया बाद में पुनः प्रयास करें/24 घंटे बाद प्रयास करें ।"
                          : "You have exceeded the limit of OTP requests, which is set to 4 times. Please try again later / try after 24 hours."}
                      </div>
                    )}
                  </div>
                )}
              </div>
              {message &&
                <div
                  className="login-modal-content"
                >{message}</div>}
            </div>
            <Modal.Footer>
              <Button
                variant="dark"
                onClick={() => {
                  setPhoneModel(false);
                }}
              >
                {t("back_tr")}
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )
      }
    </>
  );
};

